import React from 'react';
import { TabbedSectionStyles as S } from './TabbedSection.styles';
import { Grid } from '@helpers/grid';
import { withMotionMax } from '@hoc/withMotionMax';
import { ReactComponent as Arrow } from '@img/icons/arrow-short.svg';
import { ReactComponent as Chevron } from '@img/icons/chevron-left.svg';
import { imageUrl } from '@helpers/imageUrl';
import DownloadCard from '@stories/Components/Cards/DownloadCard/DownloadCard';
import { MediaComponent } from '@helpers/mediaComponent';
import withWidget from '@hoc/withWidget';
import { HydrateOption } from '@core/enums';
export var TabType;
(function (TabType) {
    TabType[TabType["RichText"] = 0] = "RichText";
    TabType[TabType["FAQ"] = 1] = "FAQ";
    TabType[TabType["Files"] = 2] = "Files";
})(TabType || (TabType = {}));
const Collapse = ({ faq }) => {
    const [open, setOpen] = React.useState(false);
    return (React.createElement(S.FAQWrapper, { "data-open": open, onClick: () => setOpen(!open) },
        React.createElement(S.FAQTitle, { size: "regular" },
            faq.title,
            " ",
            React.createElement(Chevron, null)),
        React.createElement(S.FAQBody, { open: open },
            React.createElement(S.FAQInner, { dangerouslySetInnerHTML: { __html: faq.body } }))));
};
const TabbedSection = ({ tabs, translations }) => {
    const headings = React.useMemo(() => tabs.map((x) => x.title), [tabs]);
    const [currentTab, setCurrentTab] = React.useState(headings[0]);
    const [hoveredTab, setHoveredTab] = React.useState(null);
    return (React.createElement(S.Container, null,
        React.createElement(Grid.Default, null,
            React.createElement(S.Tabs, null, headings.map((heading, i) => (React.createElement(S.Tab, { "data-wide": i === 0 && tabs.length % 2 !== 0, "data-current": currentTab === heading, key: `TabbedSection_${i}`, onClick: () => setCurrentTab(heading), onMouseEnter: () => setHoveredTab(heading), onMouseLeave: () => setHoveredTab(null) },
                heading && (React.createElement(S.TabButtonTitle, { "data-specificity": 1, semantic: "h2", visual: "h5", "data-current": currentTab === heading }, heading)),
                currentTab === heading && (React.createElement(S.BackgroundAnimation, { layoutId: "TabbedSection_Animation" })),
                React.createElement(MediaComponent, { desktop: true },
                    React.createElement(S.Arrow, { key: `TabbedSection_Arrow`, "data-hovered": hoveredTab === heading, "data-current": currentTab === heading },
                        React.createElement(Arrow, null))))))),
            React.createElement(S.Content, null, tabs.map((tab, i) => (React.createElement(S.Layout, { type: tab.type === TabType.RichText && !!tab.image ? 'split' : 'full', "data-current": currentTab === tab.title, key: `TabbedSection_Tab_${tab.title}_${i}` },
                React.createElement(S.MainContent, null,
                    React.createElement(S.ContentWrapper, null,
                        React.createElement(S.TabTitle, { semantic: "h2", visual: "h5" }, tab.title),
                        (tab.type === TabType.RichText || tab.type === TabType.Files) && tab.content && (React.createElement(S.RichTextContent, { dangerouslySetInnerHTML: { __html: tab.content } })),
                        tab.type === TabType.Files && tab.files && (React.createElement(S.Files, null, tab.files.map((file, i) => (React.createElement(DownloadCard, { key: `TabbedSection_${tab.title.replace(/ /g, '')}_${i}`, ...file, translations: translations }))))),
                        tab.type === TabType.FAQ && tab.faqs?.length > 0 && (React.createElement(S.FAQList, null, tab.faqs.map((faq, i) => (React.createElement(Collapse, { key: `TabbedSection_FAQ_${i}`, faq: faq }))))))),
                tab.type === TabType.RichText && tab.image && (React.createElement(S.ImageContainer, null,
                    React.createElement("img", { loading: "lazy", width: 528, alt: tab.title, src: imageUrl(tab.image, { width: 528 }) }))))))))));
};
export default withWidget(withMotionMax(TabbedSection), 'TabbedSection', {
    hydrate: HydrateOption.InView,
});
